import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';
import { TemplateUtenteAddComponent } from './template-utente-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [template-utente-mod-add]',
  templateUrl: 'template-utente-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class TemplateUtenteModAddComponent {
  @Output() onReturn: EventEmitter<UtenteProfilo> = new EventEmitter<UtenteProfilo>();
  @ViewChild('formAddTemplateUtente') modaleTemplateUtente: TemplateUtenteAddComponent;

  inizializza(urlAdd: string, utente: UtenteProfilo, templateUtente: TemplateUtenteProfilo) {
    this.modaleTemplateUtente.inizializza(urlAdd, utente, templateUtente);
    openModal('modalmodaddtemplateutente');
  }

  createForm() {
    this.modaleTemplateUtente.createForm();
  }

  manageModal(templateUtente: UtenteProfilo) {
      closeModal('modalmodaddtemplateutente');
      this.onReturn.emit(templateUtente);
  }
}
